module.exports = __webpack_public_path__ + "img/Rural-Roads.7c182ac8.png";